import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonBack from '../../../components/Editor/ButtonBack';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: { parentFolderId },
	} = state;

	return {
		parentId: parentFolderId,
	};
};

export default connect(mapStateToProps)(ButtonBack);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonBack/index.tsx